import type { EditorGraphMode, EditorGraphSlot, RenderSlot } from '../state/appState.js';

interface ViewportRenderModeState {
  editorGraphMode: EditorGraphMode;
  editorGraphSlot: EditorGraphSlot;
}

function slotLabel(slot: RenderSlot): string {
  return slot === 'material' ? 'Material' : 'Geometry';
}

function renderSlotForEditorSlot(slot: EditorGraphSlot): RenderSlot {
  return slot === 'material' ? 'material' : 'geometry';
}

export function syncViewportRenderModeControls(
  state: ViewportRenderModeState,
  renderedSlot: RenderSlot = renderSlotForEditorSlot(state.editorGraphSlot),
): void {
  const viewportArea = document.getElementById('viewport-area');
  if (viewportArea) viewportArea.dataset.renderSlot = renderedSlot;

  const buttons = document.querySelectorAll<HTMLButtonElement>('[data-viewport-render-mode]');
  for (const button of buttons) {
    const mode = button.dataset.viewportRenderMode;
    const active = mode === state.editorGraphMode;
    const currentRenderSlot = state.editorGraphMode === 'auto' && mode === renderedSlot;
    button.classList.toggle('active', active);
    button.classList.toggle('current-render-slot', currentRenderSlot);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');

    if (mode === 'auto') {
      const renderedLabel = slotLabel(renderedSlot);
      button.textContent = 'Auto';
      button.title = `Follow editor graph (${renderedLabel})`;
    } else if (mode === 'geometry' || mode === 'material') {
      button.title = currentRenderSlot ? `Currently rendering ${slotLabel(renderedSlot)}` : `Render ${slotLabel(mode)}`;
    }
  }
}
